const $ = jQuery;

export function blogSocialShare(socialNetworkKey, articleToBeSharedUrl){
    const socialNetworkName = socialNetworkKey.charAt(0).toUpperCase() + socialNetworkKey.slice(1);
    const currentPageUrl = window.location.href;
    
    dataLayer.push({
        event: 'social-share',
        pagePath: currentPageUrl, 
        'social-network': `${socialNetworkName}-${articleToBeSharedUrl}`,
    });
}

export function addSocialLinkClickHandlers() {
    addSocialClickHandlersBySelector('.social-button');
}

export function addSocialClickHandlersBySelector(selector){
    $(selector).on('click', function() {
        const self = $(this);
        let socialNetworkKey = self.attr('data-name');
        let articleToBeSharedUrl = self.attr('href');
        const pinterestUrl = self.attr('data-pin-media');
        //check type of attribute value since might be empty on staging or local with broken images
        if(pinterestUrl || typeof pinterestUrl === 'string'){
            socialNetworkKey = 'pinterest';
            articleToBeSharedUrl = pinterestUrl;
        }
        blogSocialShare(socialNetworkKey, articleToBeSharedUrl);
    });
}